<template>
  <div class="page-container">
    <div class="query-title">物流异常单据查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportPage" />
            <table-button name="add" tip="新增" @click="add" />
            <table-button name="apply" tip="推送安吉" @click="sendToAnji" />
            <table-button name="apply" tip="处理跟进" @click="handleFollowUp" />
            <table-button name="cancle" tip="取消异常" @click="closeBill" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #abnoramlBillCode="{ row }">
              <el-link type="primary" @click="toDetail(row)">{{ row.abnoramlBillCode }}</el-link>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import {
  apiQueryAbnormalLogistic,
  apiCloseAbnormalByIds,
  apiSendAbnormalLogistic
} from '@/api/applyForGoods/logisticsAbnormal'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/logisticsAbnormal'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
    this.tableSort.push({ field_name: 'createdDate', field_sort: 'X' })
  },
  methods: {
    async exportPage() {
      const params = {
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, apiQueryAbnormalLogistic)
      frontExport(this.gridOptions.columns, data, '物流异常单据')
    },
    add() {
      this.$router.push({
        path: '/wly/to-goods/business-processing/logistics-exceptionhandling'
      })
    },
    toDetail(row) {
      this.$router.push({
        path: '/wly/to-goods/business-processing/logistics-exceptionhandling',
        query: {
          id: row.id,
          status: row.status
        }
      })
    },
    async sendToAnji() {
      const checkData = this.$refs.xTable.getCheckboxRecords()
      // console.log("9-==========",checkData);
      if (checkData?.length && checkData.length >= 1) {
        let flag = 1
        this.abnormalBillCodeList = []
        checkData.forEach((item, index) => {
          if (item.status != 'E002' && item.status != 'E005') {
            flag = 0
          }
          this.abnormalBillCodeList.push({
            abnoramlBillCode: item.abnoramlBillCode
          })
        })
        if (flag === 0) {
          this.$message.warning('请选择已经提交或处理完成的数据进行推送！')
          return
        }
        this.$confirm('是否确认推送异常单数据给安吉?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const { data } = await apiSendAbnormalLogistic(this.abnormalBillCodeList)
          if (data.status === '1') {
            this.queryData()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
      } else {
        this.$message.warning('请选择异常单数据进行推送！')
      }
    },
    handleFollowUp() {
      const data = this.$refs.xTable.getCheckboxRecords()
      if (data?.length && data.length === 1) {
        this.$router.push({
          path: '/wly/to-goods/business-processing/logistics-exceptionhandling',
          query: {
            id: data[0].id,
            status: data[0].status
          }
        })
      } else {
        this.$message.warning('请选择一条数据进行跟进！')
      }
    },
    async closeBill() {
      const data = this.$refs.xTable.getCheckboxRecords()
      if (data?.length) {
        let resu = '0'
        data.forEach(item => {
          if (item.status === 'E005') {
            this.$message.warning('不能选择已经关闭的单据！')
            resu = '1'
          }
        })
        if (resu === '0') {
          this.$confirm('是否确认关闭此异常单据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async() => {
            const { data: res } = await apiCloseAbnormalByIds(data)
            if (res === '1') {
              this.queryData()
              this.$message.info('关闭异常单成功！')
            }
          })
        }
      } else {
        this.$message.warning('请选择一条数据进行操作！')
      }
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data: { Rows, Total }, calculation, field } = await apiQueryAbnormalLogistic(params)
        if (Rows.length === 0 && Total) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = Total - 0
        this.calculation = this.filtercalculation(calculation, 'xTable', true)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(Rows)
        } else {
          this.gridOptions.data = Rows.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field, 'xTable', true)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/logisticsAbnormal.vue